export default __webpack_public_path__ + "static/media/exceed.927d47b9.gif";